import { render, staticRenderFns } from "./connection.vue?vue&type=template&id=71992518&scoped=true&"
import script from "./connection.vue?vue&type=script&lang=ts&"
export * from "./connection.vue?vue&type=script&lang=ts&"
import style0 from "./connection.vue?vue&type=style&index=0&id=71992518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71992518",
  null
  
)

export default component.exports